import { render, staticRenderFns } from "./FasyankesEdit.vue?vue&type=template&id=10b87989&scoped=true"
import script from "./FasyankesEdit.vue?vue&type=script&lang=js"
export * from "./FasyankesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b87989",
  null
  
)

export default component.exports